import Navigation from './Navigation';

export default function EditNavigation({ isEditAllowed }: { isEditAllowed: boolean }) {
  return (
    <div className="py-4">
      <Navigation isEditAllowed={isEditAllowed} />
    </div>
  );
}
